module.exports = __webpack_public_path__ + "static/media/SF-1-if-correct.00699a08.mp3";